import Notification from '../models/notification'
import api from '../../api/v2/api'
import { ApiError } from '../../api/v2/api/base/response'

class NotificationState {
  notifications: Notification[] = []
  isLoading = false
  errorMessage = ''
  unread = 0

  async getNotification({ checkNotification = false }: { checkNotification: boolean }){
    try {
      this.isLoading = true
      this.errorMessage = ""
      const response = await api.notification.get({ checkNotification })
      this.notifications = response.notifications
      this.unread = response.unread
    } catch (error) {
      this.errorMessage = error instanceof ApiError ? error.messages : "Unknow Error"
    } finally {
      this.isLoading = false
    }
  }

  async markReaded({ id }: { id: number }){
    try {
      this.isLoading = true
      this.errorMessage = ""
      api.notification.markReaded(id)
    } catch (error) {
      this.errorMessage = error instanceof ApiError ? error.messages : "Unknow Error"
    } finally {
      this.isLoading = false
    }
  }
}

export const notificationState = new NotificationState()
